// Shared look of essence checkbox lists (desktop filter sidebar and mobile category drawer)
export const essenceListSx = {
    // Category / "Esencje" headers in the heading serif, like the product page accordions.
    '& .accordion-header .title': {
        fontFamily: 'var(--font-serif)',
        fontSize: '1.2rem',
        fontWeight: 400,
        letterSpacing: '0.03em',
    },
    '& .accordion-header .expand-sign': { fontWeight: 300 },
    '& .essence-list': {
        display: 'flex',
        flexDirection: 'column',
    },
    '& .inputItem': {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        minHeight: 44, // comfortable touch target on phones
        px: 1.5,
        py: 1.25,
        boxSizing: 'border-box',
        borderBottom: '1px solid',
        borderColor: 'divider',
        cursor: 'pointer',
        color: 'text.primary',
        // Essence labels: light sans, slightly tracked.
        fontFamily: 'var(--font-sans)',
        fontSize: '0.88rem',
        fontWeight: 300,
        letterSpacing: '0.05em',
        lineHeight: 1.4,
        textTransform: 'capitalize',
        transition: 'background-color .15s',
        '&:last-of-type': { borderBottom: 'none' },
        '&:hover': { bgcolor: 'action.hover' },
    },
    // Custom square checkbox so it looks the same on iOS, Android and desktop.
    '& .inputItem input': {
        appearance: 'none',
        WebkitAppearance: 'none',
        position: 'relative',
        width: 16,
        height: 16,
        m: 0,
        flexShrink: 0,
        border: '1px solid',
        borderColor: 'text.primary',
        borderRadius: 0,
        bgcolor: 'transparent',
        cursor: 'pointer',
        transition: 'background-color .15s, border-color .15s',
        '&:checked': {
            bgcolor: 'text.primary',
        },
        // Check mark: a rotated L drawn with two borders.
        '&:checked::after': {
            content: '""',
            position: 'absolute',
            left: '4.5px',
            top: '1px',
            width: '4px',
            height: '8px',
            border: 'solid',
            borderColor: 'background.default',
            borderWidth: '0 1.5px 1.5px 0',
            transform: 'rotate(45deg)',
        },
        '&:focus-visible': {
            outline: '1px solid',
            outlineColor: 'text.primary',
            outlineOffset: '2px',
        },
    },
};
